import gql from 'graphql-tag';

export const GET_RECEIPT = gql`
    query(
        $settle_no: String!
    ) {
        GetReceipt(
            settle_no: $settle_no
        ) {
            Receipt {
                settle_no
                reserve_no
                member_no
                golf_code
                play_date
                receipt_no
                receipt_date
                member_name
                receipt_amount
                reserve_date
                holder_no
                proviso_str
                receipts_prints
                zip_code
                golf_name
                company_name
                prefecture_name
                municipality_name
                local_name
                building_name
                telephone
                fax
            }
            ReceiptTaxs {
                tax_no
                tax_name
                tax_amount
            }
            ReceiptPays {
                payment_no
                payment_type
                payment_amount
            }
        }
    }
`;

export const PRINT_RECEIPT = gql`
    query(
        $settle_no: String!,
        $processing_kbn: Int!
        $receipt_addressee: String
    ) {
        PrintReceipt(
            settle_no: $settle_no,
            processing_kbn: $processing_kbn,
            receipt_addressee: $receipt_addressee
        ) {
            result
        }
    }
`;
export const GET_RECEIPT_ADDRESSEE = gql`
    query(
        $settle_no: String!
    ) {
        GetReceiptAddressee(
            settle_no: $settle_no
        ) {
            ReceiptAddressee {
                member_name
            }
        }
    }
`;
